import { call, takeLatest } from 'redux-saga/effects';
import { axiosT2 } from 'Utils/axios';
import { getToken } from 'Utils/storage';
import { SAMPLE_GET_API } from '../redux/sample/types';
import { getUserInfo } from '../utils/helpers';
import { SAMPLE_GET_API_URL } from '../services/APIs/sample';

function* handleSampleGetApi(action) {
  const headers = {
    token: getToken(),
  };

  // eslint-disable-next-line no-unused-vars
  const userInfo = getUserInfo();

  try {
    yield call(axiosT2.get, SAMPLE_GET_API_URL, action.payload, {
      headers,
    });
  } catch (e) {
    console.log('e:', e);
  }
}

export function* sampleSaga() {
  yield takeLatest(SAMPLE_GET_API, handleSampleGetApi);
}
